import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/svg/arrow-white-icon.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "reviews-block" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "reviews-slider wow-total animate__fadeInUp" }
const _hoisted_5 = { class: "slide" }
const _hoisted_6 = {
  key: 0,
  class: "desktop"
}
const _hoisted_7 = { class: "review-content" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "review-author" }
const _hoisted_10 = { class: "review-picture" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "tablet-mobile"
}
const _hoisted_13 = { class: "review-title" }
const _hoisted_14 = { class: "review-picture" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "review-author" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "review-slider-navigation"
}
const _hoisted_19 = {
  ref: "prev",
  class: "btn swiper-button prev"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "prev slide arrow"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  ref: "next",
  class: "btn swiper-button next"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "next slide arrow"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  ref: "pagination",
  class: "pagination"
}
const _hoisted_26 = { class: "rate-list wow-total animate__fadeInUp" }
const _hoisted_27 = { class: "rate-logo" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "rate-description" }
const _hoisted_30 = { class: "rate-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        class: "title wow-total animate__fadeInUp",
        innerHTML: _ctx.pageData['reviewTitle']
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_swiper, {
          modules: _ctx.modules,
          "slides-per-view": 1,
          "space-between": 50,
          loop: true,
          pagination: {clickable: true, el:_ctx.pagination},
          navigation: {prevEl:_ctx.prev,nextEl:_ctx.next},
          creativeEffect: {
              prev: {
                shadow: true,
                translate: ['-120%', 0, -500],
              },
              next: {
                shadow: true,
                translate: ['120%', 0, -500],
              },
            },
          effect: "creative"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData['reviewSlides'], (slide) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: slide['reviewSlidesAuthor']
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", {
                              class: "review-text",
                              innerHTML: slide['reviewSlidesDescription']
                            }, null, 8, _hoisted_8),
                            _createElementVNode("h3", _hoisted_9, [
                              _createElementVNode("b", null, _toDisplayString(slide['reviewSlidesAuthor']), 1),
                              _createElementVNode("span", null, _toDisplayString(slide['reviewSlidesPosition']), 1)
                            ])
                          ]),
                          _createElementVNode("picture", _hoisted_10, [
                            _createElementVNode("img", {
                              src: slide['reviewSlidesPhotoDesktop'],
                              alt: "reviewer photo"
                            }, null, 8, _hoisted_11)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("picture", _hoisted_14, [
                              _createElementVNode("img", {
                                src: slide['reviewSlidesPhotoMobile'],
                                alt: "reviewer photo"
                              }, null, 8, _hoisted_15)
                            ]),
                            _createElementVNode("h3", _hoisted_16, [
                              _createElementVNode("b", null, _toDisplayString(slide['reviewSlidesAuthor']), 1),
                              _createElementVNode("span", null, _toDisplayString(slide['reviewSlidesPosition']), 1)
                            ])
                          ]),
                          _createElementVNode("p", {
                            class: "review-content",
                            innerHTML: slide['reviewSlidesDescription']
                          }, null, 8, _hoisted_17)
                        ]))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules", "pagination", "navigation"]),
        (_ctx.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", _hoisted_19, _hoisted_21, 512),
              _createElementVNode("button", _hoisted_22, _hoisted_24, 512)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, null, 512))
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData['reviewRates'], (rateEl) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "rate-el",
            key: rateEl['reviewRatesLogo']
          }, [
            _createElementVNode("picture", _hoisted_27, [
              _createElementVNode("img", {
                class: "image",
                src: rateEl['reviewRatesLogo'],
                alt: "rate logo"
              }, null, 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, "Our rate is " + _toDisplayString(rateEl['reviewRatesRate']) + " of 5", 1),
              _createElementVNode("div", {
                class: "rate-stars",
                style: _normalizeStyle(`--rating: ${rateEl['reviewRatesRate']};`)
              }, null, 4)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}